import { render } from "./ProjectKPI.vue?vue&type=template&id=0808fe9c&ts=true"
import script from "./ProjectKPI.ts?vue&type=script&lang=ts"
export * from "./ProjectKPI.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__